export default "__VITE_ASSET__YZsm0EQu__"